<template>
  <b-row class="form-input-image">
    <b-col class="d-flex align-items-stretch">
      <div class="form-input-image-bg" :style="bg_imagem">
        <label :for="file_id" />
        <b-form-file
          v-model="data_imagem.file"
          @change="changeImage"
          class="form-input-file"
          accept="image/*"
          :id="file_id"
        />
      </div>
    </b-col>
    <b-col cols="8">
      <b-form-group label="Legenda:">
        <b-form-input
          v-model="value.legenda"
          placeholder="legenda"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Tags:">
        <b-form-tags v-model="value.tags" no-outer-focus class="mb-2">
          <template
            v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }"
          >
            <b-input-group aria-controls="my-custom-tags-list">
              <input
                v-bind="inputAttrs"
                v-on="inputHandlers"
                placeholder="Nova Tag - Enter para adicionar"
                class="form-control"
              />
              <b-input-group-append>
                <b-button @click="addTag()" variant="primary">
                  <font-awesome-icon icon="fas fa-plus" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <ul
              id="my-custom-tags-list"
              class="list-unstyled d-inline-flex flex-wrap mb-0"
            >
              <b-card
                v-for="tag in tags"
                :key="tag"
                :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                tag="li"
                class="mt-1 mr-1"
                body-class="py-1 px-1 text-nowrap"
              >
                <strong class="pr-2">{{ tag }}</strong>
                <b-button
                  @click="removeTag(tag)"
                  variant="outline-danger"
                  size="sm"
                  ><font-awesome-icon icon="far fa-trash-alt"
                /></b-button>
              </b-card>
            </ul>
          </template>
        </b-form-tags>
      </b-form-group>
    </b-col>
    <b-button
      size="sm"
      variant="secondary"
      v-b-modal.modal-banco-imagens
      class="form-input-banco-imagem"
      >Buscar Imagem</b-button
    >
    <b-modal
      id="modal-banco-imagens"
      ref="modal-banco-imagens"
      title="Selecione uma Imagem"
      size="xl"
      scrollable
      ok-only
      ok-title="Fechar"
      ok-variant="secundary"
    >
      <div class="text-center">Em construção</div>
    </b-modal>
  </b-row>
</template>

<script>
import { merge } from "lodash";

export const default_image_data = {
  file: null,
  legenda: null,
  tags: [],
};

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    data_imagem: default_image_data,
    selectedFile: null,
    id: "",
  }),
  computed: {
    image_show() {
      let response = null;
      if (this.selectedFile) {
        response = this.selectedFile;
      } else if (this.value && this.value.url) {
        response = this.value.urls["w-400"];
      }
      return response;
    },
    file_id() {
      return "image-" + this.id;
    },
    bg_imagem() {
      return this.image_show
        ? 'background-image: url("' + this.image_show + '")'
        : "";
    },
  },
  methods: {
    changeImage(evt) {
      evt.preventDefault();
      let file = evt.target.files[0];
      this.data_imagem.legenda = file.name;
      this.selectedFile = URL.createObjectURL(file);
    },
  },
  watch: {
    data_imagem: {
      deep: true,
      handler: function (new_value) {
        merge(this.value, new_value);
      },
    },
  },
  mounted() {
    this.id = this._uid;
  },
};
</script>

<style lang="scss">
.b-form-tags-list {
  .badge {
    font-size: 0.8rem;
    font-weight: normal;
    margin-right: 0.5em;

    span {
      margin-right: 0.6em;
    }

    .close {
      font-size: 1rem;
    }
  }
}

.form-input-image {
  display: flex;
  justify-content: center;
  position: relative;

  .form-input-image-bg {
    width: 100%;
    min-height: 120px;
    border: 1px solid #c7c7c7;
    border-radius: 5px;

    background-image: url("~@/assets/icones/no-image.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: stretch;

    label {
      width: 100%;
      display: flex;
      align-items: stretch;

      &::after {
        content: "Clique para adicionar ou alterar a imagem";
        display: flex;
        align-self: center;
        text-align: center;
        background-color: #f1f1f1;
        position: absolute;
        padding: 1rem;
        width: calc(100% - 30px);
        transition: all 0.5s;
        opacity: 0;
      }

      &:hover {
        &::after {
          opacity: 1;
        }
      }
    }

    .form-input-file {
      position: absolute;
      opacity: 0;
    }
  }

  .form-input-banco-imagem {
    position: absolute;
    right: 15px;
    top: -30px;
  }
}
</style>

